import { AreaChart } from "@mantine/charts";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import { ColorSwatch, Group, Paper, Text } from "@mantine/core";
import LoaderStats from "../../LoaderStats";
import { useMemo } from "react";
import { getChartColors } from "../../../../../functions/utilFunctions";
import { useLanguage } from "../../../../../stores/LanguageStore";

function transformData(data) {
  const result = [];

  data.forEach((entry) => {
    const campaignId = entry.prog.id;

    entry.stats.forEach((stat) => {
      // Check if the date already exists in the result
      let existingEntry = result.find((r) => r.date === stat.date);

      if (!existingEntry) {
        // If not, create a new entry for this date
        existingEntry = { date: stat.date };
        result.push(existingEntry);
      }

      // Add the sent field for the current campaign
      existingEntry[`sent_${campaignId}`] = stat.sent;
    });
  });

  return result;
}

const SmsSummaryMulti = () => {
  const lang = useLanguage(s => s.language)
  const progStats = useReportingStore((s) => s.progStats);

  const data = useMemo(() => {
    return transformData(progStats);
  }, [progStats]);

  const series = useMemo(() => {
    return progStats.map((item, index) => ({
      name: `sent_${item.prog.id}`,
      label: `${item.prog.workflow_name}`,
      color: `${getChartColors()[index]}.5`,
    }));
  }, [progStats]);

  return (
    <Paper pos={"relative"} w={"100%"} p={"xl"} pt={"md"}>
      <LoaderStats isDate />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.volume_per_campaigns}
        </Text>
      </Group>

      <AreaChart
        h={300}
        w={"100%"}
        data={data}
        type="default"
        dataKey="date"
        withDots
        withGradient
        series={series}
        // tickLine="y"
        yAxisLabel="Volume"
        xAxisLabel="Date"
        barProps={{ isAnimationActive: true, animationDuration: 600 }}
      />

      <Group mt={16} justify="center" gap={"xl"}>
        {progStats.map((item, index) => {
          return (
            <Group key={item.prog.id} gap={"xs"}>
              <ColorSwatch
                color={`var(--mantine-color-${getChartColors()[index]}-5)`}
                size={16}
              />
              <Text size="sm">
                {item.prog.workflow_name} #{item.prog.id}
              </Text>
            </Group>
          );
        })}
      </Group>
    </Paper>
  );
};

export default SmsSummaryMulti;
